<script setup lang="ts">
import { ICON_PATHS, type IconName } from './icons'

const props = withDefaults(defineProps<{ name: IconName; size?: 'sm' | 'md' }>(), { size: 'md' })
</script>

<template>
  <!-- Always decorative. Every icon-only control carries its own accessible
       name, so exposing the glyph would only double the announcement. -->
  <svg
    class="mp-icon"
    :class="`mp-icon--${props.size}`"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path :d="ICON_PATHS[props.name]" />
  </svg>
</template>

<style scoped>
.mp-icon {
  flex: none;
  display: block;
}

.mp-icon--md {
  inline-size: var(--space-5);
  block-size: var(--space-5);
}

.mp-icon--sm {
  inline-size: var(--space-4);
  block-size: var(--space-4);
}
</style>
